import { useState } from "react";
import { estadosSolicitud } from "@/lib/solicitudEstados";

interface FiltrosSolicitudesProps {
  q: string;
  estado: string;
  servicio: string;
  servicios: string[];
  resultCount: number;
  total: number;
  onQ: (value: string) => void;
  onEstado: (value: string) => void;
  onServicio: (value: string) => void;
  onClear: () => void;
}

const fieldClass =
  "w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-800 placeholder:text-foreground-400 transition-colors focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100";

export default function FiltrosSolicitudes({
  q,
  estado,
  servicio,
  servicios,
  resultCount,
  total,
  onQ,
  onEstado,
  onServicio,
  onClear,
}: FiltrosSolicitudesProps) {
  const [open, setOpen] = useState(false);
  const hasFilters = Boolean(q || estado || servicio);

  const filters = (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      <div className="relative">
        <i
          className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base leading-none text-foreground-400"
          aria-hidden="true"
        ></i>
        <input
          type="search"
          value={q}
          onChange={(event) => onQ(event.target.value)}
          placeholder="Buscar por número, cliente o correo"
          aria-label="Buscar solicitudes"
          className={`${fieldClass} pl-9`}
        />
      </div>
      <select
        value={estado}
        onChange={(event) => onEstado(event.target.value)}
        aria-label="Filtrar por estado"
        className={fieldClass}
      >
        <option value="">Todos los estados</option>
        {estadosSolicitud.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      <select
        value={servicio}
        onChange={(event) => onServicio(event.target.value)}
        aria-label="Filtrar por servicio"
        className={fieldClass}
      >
        <option value="">Todos los servicios</option>
        {servicios.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>
    </div>
  );

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-label text-foreground-600">
          <strong className="font-semibold text-foreground-950">{resultCount}</strong> de {total}{" "}
          solicitudes
        </p>
        <div className="flex items-center gap-2">
          {hasFilters && (
            <button
              type="button"
              onClick={onClear}
              className="cursor-pointer text-sm font-label font-medium text-primary-700 transition-colors hover:text-primary-800"
            >
              Limpiar
            </button>
          )}
          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            aria-expanded={open}
            className="flex cursor-pointer items-center gap-1.5 rounded-md border border-background-300 px-3 py-2 text-sm font-label font-medium text-foreground-700 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className="ri-filter-3-line text-base leading-none" aria-hidden="true"></i>
            Filtros
            {hasFilters && <span className="h-1.5 w-1.5 rounded-full bg-primary-500" aria-hidden="true"></span>}
          </button>
        </div>
      </div>

      <div className={`mt-4 ${open ? "block" : "hidden md:block"}`}>{filters}</div>
    </div>
  );
}